import $ from 'jquery';
import { BucketUICollection } from "../containers";
import { Switchboard } from '../../../../events';
import { BucketUI } from './BucketUI';
export class ColorUIManager {
    constructor() {
        this.legend = $('#colorize-legend');
        this.details = $('<div class="layer active" id="COLORIZED"></div>');
        this.buckets = new BucketUICollection();
        this.broadcaster = Switchboard.get_emitter("COLOR");
    }
    hide_legend() {
        this.legend.addClass('hidden');
    }
    show_legend() {
        this.legend.removeClass('hidden');
    }
    populate_legend(field, colorboundarymap) {
        this.legend.empty();
        const new_details = this.construct_legend(field, colorboundarymap);
        this.update_details(new_details);
        this.show_legend();
    }
    construct_legend(field, colorboundaryarray) {
        let lgd = $('<div class="legend"></div>');
        lgd.append($(`<div><b>${field}</b></div>`));
        for (let item of colorboundaryarray) {
            item.label_element.on('click', (e) => {
                this.toggle_bucket(item.label);
            });
            item.label_element.on('contextmenu', (_e) => {
                this.invert_bucket(item.label);
            });
            lgd.append(item.label_element);
            this.buckets.add(new BucketUI(item.color_element, item.label_element));
        }
        lgd.append('<div class="category"></div>');
        return lgd;
    }
    toggle_bucket(name) {
        let bucket = this.buckets.get(name);
        bucket.mapOrElse(() => {
            console.warn("Requested toggle of invalid bucket: " + name);
        }, (b) => {
            this.broadcaster.emit("change", ["toggle", name]);
            b.toggle();
        });
    }
    invert_bucket(name) {
        let bucket = this.buckets.get(name);
        if (bucket.isNone()) {
            console.warn("Requested toggle of invalid bucket: " + name);
            return;
        }
        let already_inverted = this.buckets.inverted_on(name);
        if (already_inverted) {
            this.buckets.all_on();
        }
        else {
            this.buckets.all_off_except(name);
        }
        this.broadcaster.emit("change", ["invert", name]);
    }
    update_details(details) {
        this.details.empty();
        this.details.append(details);
        this.legend.append(this.details);
    }
}
